/*
import {
  hf,
  ht,
  cr,
} from 'lib';
*/
import * as cr from './_cr';
import * as _cv_10___Mz from "./_cv_10___Mz";
import * as _cv_31___Mz from "./_cv_31___Mz";
import * as _cv_40___Mz from "./_cv_40___Mz";
import * as _cv_60___Mz from "./_cv_60___Mz";
import * as ht from './_ht';

import * as Iccv20 from './icvBaseS10Rz';

import * as Iccv27b1 from './icvI1zS40To';

export const N = (pz: {
  sPz: ht.dz,
}) => {

  return (
    cr.c(Iccv20.N, {
      key: -10,
      cz: {
        fcyName: '山内地区センター',
        pageName: 
          '実績集計表',
      },
      oClds: [

        cr.c(Iccv27b1.N, {
          key: -81,
        })

      ]
    })
  );
};
